import { ProductionItem } from "../redux/services/allocationService";

export type CycleColorScheme = {
  bg: string;
  border: string;
  text: string;
  badge: string;
};

export const formatDateForAPISimple = (dateString: string): string => {
  const date = new Date(dateString);
  date.setUTCHours(0, 0, 0, 0);
  const isoString = date.toISOString();
  return isoString.replace(/\.\d{3}Z$/, 'Z');
};

export const isSelectedDateToday = (date: string): boolean => {
  return date === getTodayDate();
};

export const isSelectedDateInPast = (date: string): boolean => {
  const today = new Date();
  const selected = new Date(date);

  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const selectedStart = new Date(
    selected.getFullYear(),
    selected.getMonth(),
    selected.getDate()
  );

  return selectedStart < todayStart;
};

export const formatTimeFromISO = (timeInput: any): string => {
  try {
    let date: Date;

    if (
      timeInput &&
      typeof timeInput === "object" &&
      timeInput._seconds !== undefined
    ) {
      date = new Date(timeInput._seconds * 1000);
    } else if (typeof timeInput === "string") {
      date = new Date(timeInput);
    } else {
      return "00:00";
    }

    if (isNaN(date.getTime())) {
      return "00:00";
    }

    // Return local time
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  } catch (error) {
    console.error("Error formatting time:", error);
    return "00:00";
  }
};

export const getTodayDate = (): string => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

export const getProductUniqueKey = (itemId: string, portionSize: string): string => {
  return `${itemId || ''}_${portionSize || ''}`;
};

export const getProductTier = (product: ProductionItem): string => {
  if (product.classFilterTag) {
    return product.classFilterTag.toLowerCase();
  }

  const lowerName = (product.displayName || '').toLowerCase();
  if (lowerName.includes('gold')) return 'gold';
  if (lowerName.includes('bronze')) return 'bronze';
  if (lowerName.includes('platinum')) return 'platinum';
  return 'bronze';
};

export const getCycleColor = (cycleId: string, index: number): CycleColorScheme => {
  const colorIndex = (index % 3) + 1;
  return {
    bg: `cycle-breakdown__table-header--cycle-${colorIndex}`,
    border: `cycle-breakdown__table-header--cycle-${colorIndex}`,
    text: `cycle-breakdown__cycle-color-text-${colorIndex}`,
    badge: `cycle-breakdown__cycle-total-badge--cycle-${colorIndex}`,
  };
};

// Delete the entire cycleColors object since it's no longer needed
export const getCycleCellClass = (cycleIndex: number): string => {
  const cycleNumber = (cycleIndex % 3) + 1;
  return `cycle-breakdown__table-cell--cycle cycle-breakdown__table-cell--cycle-${cycleNumber}`;
};

export const getCycleTotalCellClass = (cycleIndex: number): string => {
  const cycleNumber = (cycleIndex % 3) + 1;
  return `cycle-breakdown__table-cell--cycle-total cycle-breakdown__table-cell--cycle-total-${cycleNumber}`;
};

